import {
  GET_SMS_TEMPLATE_LIST,
  GET_SMS_TEMPLATE_LIST_SUCCESS,
  GET_SMS_TEMPLATE_LIST_FAIL,
  GET_SMS_TEMPLATE_DATA,
  GET_SMS_TEMPLATE_DATA_SUCCESS,
  GET_SMS_TEMPLATE_DATA_FAIL,
  ADD_SMS_TEMPLATE,
  ADD_SMS_TEMPLATE_SUCCESS,
  ADD_SMS_TEMPLATE_FAIL,
  UPDATE_SMS_TEMPLATE,
  UPDATE_SMS_TEMPLATE_SUCCESS,
  UPDATE_SMS_TEMPLATE_FAIL,
  DELETE_SMS_TEMPLATE,
  DELETE_SMS_TEMPLATE_SUCCESS,
  DELETE_SMS_TEMPLATE_FAIL,
  SEND_SMS_OUTBOUND,
  SEND_SMS_OUTBOUND_SUCCESS,
  SEND_SMS_OUTBOUND_FAIL,
  GET_SMS_ADDRESS_BOOK,
  GET_SMS_ADDRESS_BOOK_SUCCESS,
  GET_SMS_ADDRESS_BOOK_FAIL,
} from "./actionType";

const initialState = {
  smsTemplateList: {},
  smsTemplateListLoading: false,

  smsTemplateData: {},
  smsTemplateDataLoading: false,

  addSmsTemplate: {},
  addSmsTemplateLoading: false,

  updateSmsTemplate: {},
  updateSmsTemplateLoading: false,

  deleteSmsTemplate: {},
  deleteSmsTemplateLoading: false,

  sendSmsOutbound: {},
  sendSmsOutboundLoading: false,

  smsAddressBook: {},
  smsAddressBookLoading: false,

  error: {},
};

const SmsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SMS_TEMPLATE_LIST:
      return {
        ...state,
        smsTemplateListLoading: true,
      };

    case GET_SMS_TEMPLATE_LIST_SUCCESS:
      return {
        ...state,
        smsTemplateList: action.payload,
        smsTemplateListLoading: false,
      };

    case GET_SMS_TEMPLATE_LIST_FAIL:
      return {
        ...state,
        smsTemplateListLoading: false,
        error: action.payload,
      };

    case GET_SMS_TEMPLATE_DATA:
      return {
        ...state,
        smsTemplateData: {},
        smsTemplateDataLoading: true,
      };

    case GET_SMS_TEMPLATE_DATA_SUCCESS:
      return {
        ...state,
        smsTemplateData: action.payload,
        smsTemplateDataLoading: false,
      };

    case GET_SMS_TEMPLATE_DATA_FAIL:
      return {
        ...state,
        smsTemplateDataLoading: false,
        error: action.payload,
      };

    case ADD_SMS_TEMPLATE:
      return {
        ...state,
        addSmsTemplate: {},
        addSmsTemplateLoading: true,
      };

    case ADD_SMS_TEMPLATE_SUCCESS:
      return {
        ...state,
        addSmsTemplate: action.payload,
        addSmsTemplateLoading: false,
      };

    case ADD_SMS_TEMPLATE_FAIL:
      return {
        ...state,
        addSmsTemplateLoading: false,
        error: action.payload,
      };

    case UPDATE_SMS_TEMPLATE:
      return {
        ...state,
        updateSmsTemplate: {},
        updateSmsTemplateLoading: true,
      };

    case UPDATE_SMS_TEMPLATE_SUCCESS:
      return {
        ...state,
        updateSmsTemplate: action.payload,
        updateSmsTemplateLoading: false,
      };

    case UPDATE_SMS_TEMPLATE_FAIL:
      return {
        ...state,
        updateSmsTemplateLoading: false,
        error: action.payload,
      };

    case DELETE_SMS_TEMPLATE:
      return {
        ...state,
        deleteSmsTemplate: {},
        deleteSmsTemplateLoading: true,
      };

    case DELETE_SMS_TEMPLATE_SUCCESS:
      return {
        ...state,
        deleteSmsTemplate: action.payload,
        deleteSmsTemplateLoading: false,
      };

    case DELETE_SMS_TEMPLATE_FAIL:
      return {
        ...state,
        deleteSmsTemplateLoading: false,
        error: action.payload,
      };

    case SEND_SMS_OUTBOUND:
      return {
        ...state,
        sendSmsOutbound: {},
        sendSmsOutboundLoading: true,
      };

    case SEND_SMS_OUTBOUND_SUCCESS:
      return {
        ...state,
        sendSmsOutbound: action.payload,
        sendSmsOutboundLoading: false,
      };

    case SEND_SMS_OUTBOUND_FAIL:
      return {
        ...state,
        sendSmsOutboundLoading: false,
        error: action.payload,
      };

    case GET_SMS_ADDRESS_BOOK:
      return {
        ...state,
        smsAddressBookLoading: true,
      };

    case GET_SMS_ADDRESS_BOOK_SUCCESS:
      return {
        ...state,
        smsAddressBook: action.payload,
        smsAddressBookLoading: false,
      };

    case GET_SMS_ADDRESS_BOOK_FAIL:
      return {
        ...state,
        smsAddressBookLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default SmsReducer;
